var s = /* @__PURE__ */ ((U) => (U.AU = "AU", U.EU = "EU", U.GB = "GB", U.US = "US", U))(s || {});
const r = ["AU", "GB", "US"], e = ["EU"];
export {
  s as SupportedLocation,
  r as supportedCountries,
  e as supportedRegions
};
